<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout v-if="education_management" justify-start column
                      class="pa-4"
            >
                <v-breadcrumbs class=" pl-0">
                    <template #divider>
                        <v-icon>
                            keyboard_arrow_left
                        </v-icon>
                    </template>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">
                                keyboard_arrow_left
                            </v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout wrap justify-space-between align-center>
                    <h1 class="section-title-main my-3 mr-4 font-weight-regular">
                        {{ $t("Управление обучением") }}
                    </h1>
                    <buttonRed @click.native="OPEN_MODAL('add_training')">
                        {{ $t("Назначить обучение") }}
                    </buttonRed>
                </v-layout>

                <UsersEmployees />
            </v-layout>
            <div v-else class="pa-4">
                {{ $t("Доступ запрещён") }}
            </div>
        </div>
        <addStudyModal />
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonRed   from '@/components/ui/buttons/button_red';
import UsersEmployees from './Users_employees';
import {mapState, mapGetters, mapMutations} from 'vuex';
import addStudyModal from './Modals/Add_study_modal.vue';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    buttonRed,
    UsersEmployees,
    addStudyModal,
  },
  data() {
    return {
      user_analytics      : '',
      user_management     : '',
      education_management: null,
    };
  },
  computed: {
    ...mapState('users/requests', ['requests_amout']),
    ...mapGetters('users/requests', [
      'user_request_forms',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('learning_management/modals', [
      'add_training',
    ]),
  },
  mounted() {
    if (localStorage.user !== 'undefined') {
      this.education_management = this.user.role.education_management.rights.length;
    }
  },
  methods: {
    ...mapMutations('learning_management/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
  },
};
</script>
